export const VISUALIZER_CATEGORY_VALUES = {
    ANGLES: 'Angles',
    SWING_PLANE: 'Swing Plane',
    PATHS: 'Paths',
    JOINT_ANGLES: 'Joint Angles',
    DISPLACEMENT: 'Displacement',
} as const;

export const VISUALIZER_CATEGORY_KEYS = {
    ANGLES: 'ANGLES',
    SWING_PLANE: 'SWING_PLANE',
    PATHS: 'PATHS',
    JOINT_ANGLES: 'JOINT_ANGLES',
    DISPLACEMENT: 'DISPLACEMENT',
} as const;

export const VISUALIZER_LABELS: Record<string, string> = {
    NONE: 'undefined',
    HEAD: 'Head',
    SHOULDERS_MID: 'Shoulders mid',
    LEAD_WRIST: 'Lead wrist',
    TRAIL_WRIST: 'Trail wrist',
    LEAD_ANKLE: 'Lead ankle',
    TRAIL_ANKLE: 'Trail ankle',
    LEAD_KNEE: 'Lead knee',
    TRAIL_KNEE: 'Trail knee',
    LEAD_ELBOW: 'Lead elbow',
    TRAIL_ELBOW: 'Trail elbow',
    LEAD_SHOULDER: 'Lead shoulder',
    TRAIL_SHOULDER: 'Trail shoulder',
    LEAD_HIP: 'Lead hip',
    TRAIL_HIP: 'Trail hip',
    PELVIS: 'Pelvis',
    SETUP_PLANE: 'Shaft plane at setup',
    IMPACT_PLANE: 'Shaft plane at impact',
    SWING_PLANE: 'Swing plane',
    TRAIL_ELBOW_PLANE: 'Trail elbow plane at setup',
    TRAIL_SHOULDER_PLANE: 'Trail shoulder plane at setup',
    HAND_PATH: 'Hand path',
    CLUB_PATH: 'Club path',
} as const;

export const VISUALIZER_KEYS = {
    NONE: 'NONE',
    HEAD: 'HEAD',
    SHOULDERS_MID: 'SHOULDERS_MID',
    LEAD_WRIST: 'LEAD_WRIST',
    TRAIL_WRIST: 'TRAIL_WRIST',
    LEAD_ANKLE: 'LEAD_ANKLE',
    TRAIL_ANKLE: 'TRAIL_ANKLE',
    LEAD_KNEE: 'LEAD_KNEE',
    TRAIL_KNEE: 'TRAIL_KNEE',
    LEAD_ELBOW: 'LEAD_ELBOW',
    TRAIL_ELBOW: 'TRAIL_ELBOW',
    LEAD_SHOULDER: 'LEAD_SHOULDER',
    TRAIL_SHOULDER: 'TRAIL_SHOULDER',
    LEAD_HIP: 'LEAD_HIP',
    TRAIL_HIP: 'TRAIL_HIP',
    PELVIS: 'PELVIS',
    SETUP_PLANE: 'SETUP_PLANE',
    IMPACT_PLANE: 'IMPACT_PLANE',
    SWING_PLANE: 'SWING_PLANE',
    TRAIL_ELBOW_PLANE: 'TRAIL_ELBOW_PLANE',
    TRAIL_SHOULDER_PLANE: 'TRAIL_SHOULDER_PLANE',
    HAND_PATH: 'HAND_PATH',
    CLUB_PATH: 'CLUB_PATH',
} as const;

export const VISUALIZER_CATEGORIES = {
    [VISUALIZER_CATEGORY_KEYS.ANGLES]: [VISUALIZER_KEYS.HEAD, VISUALIZER_KEYS.PELVIS, VISUALIZER_KEYS.SHOULDERS_MID],
    [VISUALIZER_CATEGORY_KEYS.SWING_PLANE]: [
        VISUALIZER_KEYS.SETUP_PLANE,
        VISUALIZER_KEYS.IMPACT_PLANE,
        VISUALIZER_KEYS.SWING_PLANE,
        VISUALIZER_KEYS.TRAIL_ELBOW_PLANE,
        VISUALIZER_KEYS.TRAIL_SHOULDER_PLANE,
    ],
    [VISUALIZER_CATEGORY_KEYS.PATHS]: [VISUALIZER_KEYS.HAND_PATH, VISUALIZER_KEYS.CLUB_PATH],
    [VISUALIZER_CATEGORY_KEYS.JOINT_ANGLES]: [
        VISUALIZER_KEYS.LEAD_ELBOW,
        VISUALIZER_KEYS.TRAIL_ELBOW,
        VISUALIZER_KEYS.LEAD_KNEE,
        VISUALIZER_KEYS.TRAIL_KNEE,
    ],
    [VISUALIZER_CATEGORY_KEYS.DISPLACEMENT]: [
        VISUALIZER_KEYS.HEAD,
        VISUALIZER_KEYS.SHOULDERS_MID,
        VISUALIZER_KEYS.LEAD_ANKLE,
        VISUALIZER_KEYS.TRAIL_ANKLE,
        VISUALIZER_KEYS.PELVIS,
        VISUALIZER_KEYS.LEAD_ELBOW,
        VISUALIZER_KEYS.TRAIL_ELBOW,
        VISUALIZER_KEYS.LEAD_HIP,
        VISUALIZER_KEYS.TRAIL_HIP,
        VISUALIZER_KEYS.LEAD_KNEE,
        VISUALIZER_KEYS.TRAIL_KNEE,
        VISUALIZER_KEYS.LEAD_SHOULDER,
        VISUALIZER_KEYS.TRAIL_SHOULDER,
        VISUALIZER_KEYS.LEAD_WRIST,
        VISUALIZER_KEYS.TRAIL_WRIST,
    ],
};

type EmptySelectParams = {
    [VISUALIZER_CATEGORY_KEYS.ANGLES]: undefined;
    [VISUALIZER_CATEGORY_KEYS.JOINT_ANGLES]: undefined;
    [VISUALIZER_CATEGORY_KEYS.DISPLACEMENT]: undefined;
    [VISUALIZER_CATEGORY_KEYS.SWING_PLANE]: string[];
    [VISUALIZER_CATEGORY_KEYS.PATHS]: string[];
    displacementMode: 'displacement';
};

export const EMPTY_SELECT_PARAMS: EmptySelectParams = {
    [VISUALIZER_CATEGORY_KEYS.ANGLES]: undefined,
    [VISUALIZER_CATEGORY_KEYS.JOINT_ANGLES]: undefined,
    [VISUALIZER_CATEGORY_KEYS.DISPLACEMENT]: undefined,
    [VISUALIZER_CATEGORY_KEYS.SWING_PLANE]: [],
    [VISUALIZER_CATEGORY_KEYS.PATHS]: [],
    displacementMode: 'displacement',
};
